import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export const isAuthenticated = () => {
  try {
    return localStorage.getItem("token") !== null;
  } catch {
    return false;
  }
};

// Checks the token on every render, so a fresh login is picked up without a page reload.
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
};

export default ProtectedRoute;
